<div class="device-card" 
     [class.selected]="control?.value"
     [class.selectable]="isSelectable"
     [attr.role]="isSelectable ? 'button' : null"
     [attr.tabindex]="isSelectable ? '0' : null"
     [attr.aria-pressed]="isSelectable ? control?.value : null"
     [attr.aria-label]="'Select device ' + device.nickname + ' (' + device.number + ')'"
     (click)="onCardClick()"
     (keydown)="onCardKeyDown($event)">
    <div class="device-image-checkbox-container">
        <xm-media-image [imageOptions]="imageOptions" *ngIf="imageOptions" class="device-image"
            size="auto"></xm-media-image>
        
        <input name="checkboxId" [id]="checkboxId" role="checkbox" class="checkbox" type="checkbox"
            [checked]="control?.value" [formControl]="control" xmAriaCheckbox [isInputChecked]="control?.value" 
            [attr.aria-labelledby]="'device-label-' + index"
            tabindex="-1" />
        <label [for]="checkboxId" class="label">
            <xm-checkbox [isXMCCardSelected]="control?.value"></xm-checkbox>
        </label>
    </div>
    <div class="device-content">
        <div>
            <h3 class="device-nickname" [id]="'device-label-' + index">{{ device.nickname }}</h3>
            <p class="device-number">{{ device.number }}</p>
        </div>
        <div class="device-footer">
            <span class="xmc-price">{{ device.xmcPrice }}</span>
            <span class="device-footer-text">{{ device.footerText }}</span>
        </div>
    </div>
</div>
